import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-8" }
const _hoisted_2 = { class: "flex flex-col gap-4" }
const _hoisted_3 = { class: "font-bold text-2xl text-center" }
const _hoisted_4 = { class: "w-full flex justify-between items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "block rounded-full bg-primary text-white px-4 py-2 pi pi-angle-left !text-2xl" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "block rounded-full bg-primary text-white px-4 py-2 pi pi-angle-right !text-2xl" }, null, -1)
const _hoisted_7 = { class: "flex justify-end" }
const _hoisted_8 = { class: "grid grid-cols-1 grid-rows-auto lg:grid-cols-3 gap-2 lg:gap-4" }
const _hoisted_9 = { class: "flex flex-col gap-2" }
const _hoisted_10 = { class: "flex flex-col gap-2" }
const _hoisted_11 = { class: "flex flex-col gap-2" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "py-4 flex justify-start items-center flex-wrap gap-2" }
const _hoisted_14 = { class: "font-bold" }
const _hoisted_15 = ["title"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-bookmark" }, null, -1)
const _hoisted_17 = ["title"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-users" }, null, -1)
const _hoisted_19 = { class: "border rounded-xl divide-y" }
const _hoisted_20 = { class: "p-2 flex flex-col gap-2" }
const _hoisted_21 = { class: "flex flex-col md:flex-row justify-between" }
const _hoisted_22 = { class: "flex items-center gap-2" }
const _hoisted_23 = { class: "flex gap-2 items-center" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-bookmark !font-semibold" }, null, -1)
const _hoisted_25 = { class: "font-medium" }
const _hoisted_26 = { class: "font-light" }
const _hoisted_27 = { class: "flex gap-1 flex-row-reverse justify-end lg:flex-row" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "flex gap-2 items-center" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-calendar !font-semibold" }, null, -1)
const _hoisted_32 = { class: "font-medium" }
const _hoisted_33 = { class: "flex flex-col md:flex-row justify-between" }
const _hoisted_34 = { class: "flex gap-2 items-center md:max-w-[50%]" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-comment" }, null, -1)
const _hoisted_36 = { class: "line-clamp-1" }
const _hoisted_37 = { class: "flex gap-2 justify-end items-center" }
const _hoisted_38 = {
  key: 0,
  class: "font-light"
}
const _hoisted_39 = { class: "flex gap-2 items-center" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-users" }, null, -1)
const _hoisted_41 = { class: "h-8 flex justify-between items-center" }
const _hoisted_42 = { class: "flex justify-start items-end gap-2" }
const _hoisted_43 = {
  key: 0,
  class: "bg-green-500 text-white rounded-xl p-1 text-xs"
}
const _hoisted_44 = { class: "flex justify-end items-end gap-2" }
const _hoisted_45 = {
  key: 0,
  class: "border bg-gray-300 rounded flex justify-center text-xs"
}
const _hoisted_46 = {
  key: 0,
  class: "border-r p-1"
}
const _hoisted_47 = { class: "p-1" }

import PRating from "primevue/rating";
import CSwitch from "@/components/shared/Switch.vue";
import Filter from "@/components/shared/Filter.vue";
import PInput from "primevue/inputtext";
import { queryParamTOArray } from "@/assets/utils/index";
import { HHMMFromISO, dateToISO } from "@/assets/utils/date";
import {
  addDays,
  compareAsc,
  format,
  isValid,
  parseISO,
  subDays,
} from "date-fns";
import { clone, cloneDeep, debounce } from "lodash";
import { RouteLocationRaw, useRoute, useRouter } from "vue-router";
import { onBeforeMount, onMounted, ref, watch } from "vue";
import store from "@/store";
import { computed } from "@vue/reactivity";
import { reservationStatusList } from "@/assets/utils/translatedEnums";
import { useI18n } from "vue-i18n";
import {
  filterByServices,
  filterBySpaces,
  filterByStatus,
} from "@/assets/utils/reservations";

export default /*#__PURE__*/_defineComponent({
  __name: 'list',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const { t } = useI18n();
const searchTerm = ref("");
function filterReservatiosByClientInfo(reservations: any, term: string) {
  for (const [dateKey] of Object.entries(reservations)) {
    const filtredReservations = reservations[dateKey]?.reservations?.filter(
      (obj: any) => {
        for (const clientFieldKey in obj?.client) {
          const clientFieldValue = obj?.client[clientFieldKey];
          const isString = typeof clientFieldValue === "string";

          if (
            isString &&
            clientFieldValue?.toLowerCase()?.includes(term.toLowerCase())
          ) {
            return true;
          }
        }
        return false;
      }
    );
    reservations[dateKey].reservations = filtredReservations;
  }

  return reservations;
}

const linkToCreateReservation = computed(() => {
  const isSameDay = settings.value.startDate === settings.value.endDate;
  const url: RouteLocationRaw = { name: "AddReservation" };
  if (isSameDay) {
    url.query = {
      at: settings.value.startDate,
    };
  }
  return url;
});
const getTableName = (tableId: string) => {
  return store.getters["pos/tableById"](tableId)?.name;
};
const previousDay = computed(() => {
  return dateToISO({
    date: addDays(parseISO(settings.value.endDate), -1),
    withHHMM: false,
  });
});
const nextDay = computed(() => {
  return dateToISO({
    date: addDays(parseISO(settings.value.endDate), 1),
    withHHMM: false,
  });
});
const getSpaceName = (spaceId: string) =>
  store.getters["pos/spaceById"](spaceId)?.name;
const formatServicesOfReservation = (
  services: { id: string; name: string }[]
) => {
  return services.map((service) => service.name).join(", ");
};
const spaces = computed(() => store.getters["pos/spaces"]);
const services = computed(() => store.getters["pos/services"]);

const init = () => {
  const q = route.query;
  const startDate = isValid(new Date(q.startDate as string))
    ? (q.startDate as string)
    : dateToISO({ date: new Date(), withHHMM: false });
  let endDate = startDate;
  if (isValid(new Date(q.endDate as string))) {
    endDate =
      compareAsc(new Date(q.endDate as string), new Date(startDate)) >= 0
        ? dateToISO({ date: new Date(q.endDate as string), withHHMM: false })
        : endDate;
  }
  return cloneDeep({
    spacesIds: queryParamTOArray(q.spaceId as any),
    isOutOfService: (q.isOutOfService as any) === "false" ? false : true,
    isWithoutSpace: (q.isWithoutSpace as any) === "false" ? false : true,
    isUnknownStatus: (q.isUnknownStatus as any) === "false" ? false : true,
    servicesIds: queryParamTOArray(q.serviceId as any),
    statusIds: queryParamTOArray(q.statusId as any),
    startDate,
    endDate,
  });
};

let settings = ref<any>();

const getColor = (code: string) => {
  return `bg-${code}-500`;
};
onBeforeMount(async () => {
  settings.value = init();
  // await fetchReservations();
});

const rawReservations = ref<any>();

const title = computed(() => {
  if (settings.value.startDate === settings.value.endDate) {
    return `${t("of")} ${settings.value.startDate}`;
  } else {
    return `${t("betweenThe")} ${settings.value.startDate} ${t("andThe")} ${
      settings.value.endDate
    }`;
  }
});
const reservations = computed(() => {
  if (!rawReservations.value) {
    return null;
  }
  let result: any;
  if (searchTerm.value) {
    result = filterReservatiosByClientInfo(
      cloneDeep(rawReservations.value),
      searchTerm.value
    );
  } else {
    result = cloneDeep(rawReservations.value);
  }

  // console.log("result before any filter", result);
  const filtredServices: any =
    (settings.value.servicesIds ?? []).length > 0
      ? cloneDeep(
          settings.value.servicesIds?.map((id: string) =>
            services.value.find((s: any) => s.id === id)
          )
        )
      : cloneDeep(store.getters["pos/services"]);

  result = filterByStatus({
    reservations: cloneDeep(result),
    statuses:
      (settings.value.statusIds ?? []).length > 0
        ? cloneDeep(settings.value.statusIds ?? [])
        : cloneDeep((reservationStatusList(t) ?? []).map((s: any) => s.id)),
    includeWithoutStatus: settings.value.isUnknownStatus,
  });
  // console.log("result after status", result);

  result = filterBySpaces({
    reservations: cloneDeep(result),
    spaces:
      (settings.value.spacesIds ?? []).length > 0
        ? cloneDeep(settings.value.spacesIds ?? [])
        : cloneDeep((spaces.value ?? []).map((s: any) => s.id)),
    includeWithoutSpace: settings.value.isWithoutSpace,
  });
  // console.log("result after spaces", result);
  result = filterByServices({
    reservations: cloneDeep(result),
    services: filtredServices,
    includeOutOfService: settings.value.isOutOfService,
  });
  Object.keys(result).forEach((key: any) => {
    result[key].reservations = result[key].reservations.sort(
      (a: any, b: any) => a.at - b.at
    );
  });

  return result;
});
const fetchReservations = async () => {
  rawReservations.value = await store.dispatch("reservation/RETRIEVE", {
    startDate: settings.value.startDate,
    endDate: settings.value.endDate,
  });
};
const debounceFetchReservations = debounce(fetchReservations, 500);
watch(
  () => route,
  async (previous, current) => {
    if (previous.name === current.name) {
      settings.value = init();
    }
  },
  {
    deep: true,
  }
);
watch(
  settings,
  async (change, prev) => {
    if (
      prev?.startDate !== change?.startDate ||
      prev?.endDate !== change?.endDate
    ) {
      await debounceFetchReservations();
    }
    const query: any = {};
    query.startDate = settings.value.startDate;

    query.endDate = settings.value.endDate;

    query.statusId = settings.value.statusIds;

    query.spaceId = settings.value.spacesIds;

    query.serviceId = settings.value.servicesIds;

    query.isOutOfService = settings.value.isOutOfService;

    query.isWithoutSpace = settings.value.isWithoutSpace;

    query.isUnknownStatus = settings.value.isUnknownStatus;

    await router.replace({ name: "ReservationList", query });
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("reservations")) + " " + _toDisplayString(_unref(title)), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, {
          title: _ctx.$t('previousDay'),
          to: { name: 'ReservationList', query: { startDate: _unref(previousDay) } }
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["title", "to"]),
        _createVNode(_component_router_link, {
          title: _ctx.$t('nextDay'),
          to: { name: 'ReservationList', query: { startDate: _unref(nextDay) } }
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["title", "to"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_router_link, {
        class: "p-button font-medium !rounded-full",
        to: _unref(linkToCreateReservation)
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("NewReservation")), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(Filter, {
          "all-word": _ctx.$t('allSpaces'),
          options: _unref(spaces),
          modelValue: _unref(settings).spacesIds,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(settings).spacesIds) = $event)),
          placeholder: _ctx.$t('space')
        }, null, 8, ["all-word", "options", "modelValue", "placeholder"]),
        _createVNode(CSwitch, {
          modelValue: _unref(settings).isWithoutSpace,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(settings).isWithoutSpace) = $event))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("include")) + " " + _toDisplayString(_ctx.$t("WithoutASpace")), 1)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(Filter, {
          "all-word": _ctx.$t('allServices'),
          options: _unref(services),
          modelValue: _unref(settings).servicesIds,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(settings).servicesIds) = $event)),
          placeholder: _ctx.$t('service')
        }, null, 8, ["all-word", "options", "modelValue", "placeholder"]),
        _createVNode(CSwitch, {
          modelValue: _unref(settings).isOutOfService,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(settings).isOutOfService) = $event))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("include")) + " " + _toDisplayString(_ctx.$t("OUT_OF_SLOT")), 1)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(Filter, {
          "all-word": _ctx.$t('allStatuses'),
          options: _unref(reservationStatusList)(_ctx.$t),
          modelValue: _unref(settings).statusIds,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(settings).statusIds) = $event)),
          placeholder: _ctx.$t('status')
        }, null, 8, ["all-word", "options", "modelValue", "placeholder"]),
        _createVNode(CSwitch, {
          modelValue: _unref(settings).isUnknownStatus,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(settings).isUnknownStatus) = $event))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("include")) + " " + _toDisplayString(_ctx.$t("unknownStatus")), 1)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    (_unref(reservations))
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", null, [
            _createVNode(_unref(PInput), {
              class: "w-full",
              modelValue: searchTerm.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((searchTerm).value = $event)),
              placeholder: _ctx.$t('searchByClient'),
              icon: "pi\n        pi-search"
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_unref(reservations)), (date, dateIndex) => {
            return (_openBlock(), _createElementBlock("div", { key: dateIndex }, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("h2", _hoisted_14, _toDisplayString(date), 1),
                _createElementVNode("div", {
                  class: "flex items-center gap-2 rounded-full font-medium px-2 bg-gray-100",
                  title: _ctx.$t('reservations')
                }, [
                  _hoisted_16,
                  _createElementVNode("span", null, _toDisplayString(_unref(reservations)[date].reservationsCount), 1)
                ], 8, _hoisted_15),
                _createElementVNode("div", {
                  class: "flex items-center gap-2 rounded-full font-medium px-2 bg-gray-100",
                  title: _ctx.$t('attendeesCount')
                }, [
                  _hoisted_18,
                  _createElementVNode("span", null, _toDisplayString(_unref(reservations)[date].attendeesCount), 1)
                ], 8, _hoisted_17)
              ]),
              _createElementVNode("div", _hoisted_19, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(reservations)[date]
              .reservations, (reservation, reservationIndex) => {
                  return (_openBlock(), _createBlock(_component_router_link, {
                    to: { name: 'ReservationEdit', params: { id: reservation.id } },
                    key: reservationIndex,
                    class: "block"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("div", _hoisted_23, [
                                _hoisted_24,
                                _createElementVNode("span", _hoisted_25, _toDisplayString(reservation.client?.firstName) + " " + _toDisplayString(reservation.client?.lastName), 1)
                              ]),
                              _createElementVNode("div", _hoisted_26, _toDisplayString(reservation.client?.phoneNumber), 1)
                            ]),
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("div", null, [
                                (reservation?.servicesIn?.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                      _createElementVNode("span", null, "(" + _toDisplayString(formatServicesOfReservation(
                              reservation?.servicesIn
                            )) + ")", 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_29, "(" + _toDisplayString(_ctx.$t("OUT_OF_SLOT")) + ")", 1))
                              ]),
                              _createElementVNode("div", _hoisted_30, [
                                _hoisted_31,
                                _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(HHMMFromISO)(reservation.at)), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                              _hoisted_35,
                              _createElementVNode("span", _hoisted_36, _toDisplayString(reservation.comment), 1)
                            ]),
                            _createElementVNode("div", _hoisted_37, [
                              (reservation.createdBy)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_38, "(" + _toDisplayString(_ctx.$t("by")) + ": " + _toDisplayString(`${reservation.createdBy?.firstName ?? ""} ${
                          reservation.createdBy?.lastName ?? ""
                        }`) + ")", 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_39, [
                                _hoisted_40,
                                _createElementVNode("span", null, _toDisplayString(reservation.attendeesCount) + " " + _toDisplayString(_ctx.$t("attendeeShort")), 1)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, [
                            (reservation.isOnline)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(_ctx.$t("online")), 1))
                              : _createCommentVNode("", true),
                            (reservation.rating?.rating)
                              ? (_openBlock(), _createBlock(_unref(PRating), {
                                  key: 1,
                                  modelValue: reservation.rating.rating,
                                  cancel: false,
                                  readonly: ""
                                }, null, 8, ["modelValue"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_44, [
                            (reservation.spaceId)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                  (reservation.tableIds?.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reservation.tableIds, (tableId, tableIndex) => {
                                          return (_openBlock(), _createElementBlock("span", { key: tableIndex }, [
                                            (
                            tableIndex > 0 &&
                            tableIndex < reservation.tables?.length
                          )
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createTextVNode(" - ")
                                                ], 64))
                                              : _createCommentVNode("", true),
                                            _createTextVNode(" " + _toDisplayString(getTableName(tableId)), 1)
                                          ]))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_47, _toDisplayString(getSpaceName(reservation.spaceId)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", {
                              class: _normalizeClass(["text-white rounded-xl p-1 text-xs", [
                      getColor(
                        _ctx.$t(`RESERVATIONS_STATUS.${reservation.status}.color`)
                      ),
                    ]])
                            }, _toDisplayString(_ctx.$t(`RESERVATIONS_STATUS.${reservation.status}.text`)), 3)
                          ])
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                }), 128))
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})